import { Injectable } from "@angular/core";
import { ApiService } from "../api.service";

const PATH = "app/audience";

@Injectable({
  providedIn: "root",
})
export class AccountAppAudiencesHandlerService {
  constructor(private APIService: ApiService) {}

  getAudiences(
    masterAccountID: number,
    accountAppID: number,
    queryParams?: { page?: number; perPage?: number },
  ) {
    return this.APIService.get(`${PATH}/${masterAccountID}/${accountAppID}`, {
      params: queryParams,
    });
  }

  getAudience(
    masterAccountID: number,
    accountAppID: number,
    audienceID: number,
  ) {
    return this.APIService.get(
      `${PATH}/${masterAccountID}/${accountAppID}/${audienceID}`,
    );
  }

  postAudience(masterAccountID: number, accountAppID: number, audience: any) {
    return this.APIService.post(
      `${PATH}/${masterAccountID}/${accountAppID}`,
      audience,
    );
  }

  putAudience(
    masterAccountID: number,
    accountAppID: number,
    audienceID: number,
    audience: any,
  ) {
    return this.APIService.put(
      `${PATH}/${masterAccountID}/${accountAppID}/${audienceID}`,
      audience,
    );
  }

  deleteAudience(
    masterAccountID: number,
    accountAppID: number,
    audienceID: number,
  ) {
    return this.APIService.delete(
      `${PATH}/${masterAccountID}/${accountAppID}/${audienceID}`,
    );
  }
}
